import { Timestamp } from "../../domine/timestamp.types";
import { FirestoreFieldValue } from "./firestore.types";

export const getTimestampValue = (field: FirestoreFieldValue): string | null =>
  "timestampValue" in field ? field.timestampValue : null;

export const getIntegerValue = (field: FirestoreFieldValue): number | null =>
  "integerValue" in field ? parseInt(field.integerValue, 10) : null;

export const getDoubleValue = (field: FirestoreFieldValue): number | null =>
  "doubleValue" in field ? field.doubleValue : null;

export const getStringValue = (field: FirestoreFieldValue): string | null =>
  "stringValue" in field ? field.stringValue : null;

export const getTimestamp = (time: FirestoreFieldValue): Timestamp => {
  return {
    seconds: new Date(getTimestampValue(time)!).getTime() / 1000,
    nanoseconds: 0,
  };
}